/**
 * Returns a color numeric string (000, 100, 200, up to 1800) for DT usage
 * e.x. <DtAvatar color={getColor('some string')} />
 * @param str any string
 */
export const getColor = (str: string): string => {
  const hash = getHash(str);
  const result = Math.abs(hash % 19);
  return `${result}00`;
};

export const getColorClass = (str: string): string => {
  const hash = getHash(str);
  const result = Math.abs(hash % 18);
  return `d-fc-${COLORS_MAP[result]}`;
};

const getHash = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + (str.codePointAt(i) ?? 0);
    hash = Math.trunc(hash); // Convert to 32bit integer
  }
  return hash;
};

export const COLORS_MAP: Record<number, string> = {
  0: 'purple-200',
  1: 'purple-300',
  2: 'purple-400',
  3: 'blue-200',
  4: 'blue-300',
  5: 'blue-400',
  6: 'magenta-200',
  7: 'magenta-300',
  8: 'magenta-400',
  9: 'gold-200',
  10: 'gold-300',
  11: 'gold-400',
  12: 'green-200',
  13: 'green-300',
  14: 'green-400',
  15: 'red-200',
  16: 'red-300',
  17: 'red-400',
};
